<template>
    <div class="container">
        <UserNavigation/>
        <div class="text-wrapper">
            <h2>Reklamacija i povraćaj robe</h2>
            <p>Postupak rešavanja reklamacije sprovodi se na osnovu odredbi Zakona o zaštiti potrošača (“Sl.Glasnik RS” br. 62/2014) kao i odredbi Zakona o trgovini (“Sl.Glasnik RS” br. 53/10, 10/2013).</p>
            <p>Na zamenu neispravnih proizvoda imate pravo ako je na proizvodu jasno vidljivo da greška nije nastala nepravilnim korišćenjem već da je došlo do greške u proizvodnji, pakovanju ili transportu. Rok za odgovor na reklamaciju je 8 dana od prijema reklamacije. Rok za rešavanje je 15 dana od prijema reklamacije. Povrat robe se u tom slučaju vrši na naš trošak a prijava ide u jednostavna tri koraka:</p>
            <ol>
                <li>
                    Pošaljite Vaš zahtev našem operateru na adresu: olivia.sapuni@gmail.com
                    <br>
                    Obavezno navedite sledeće podatke:
                    <ul>
                        <li>Ime i prezime</li>
                        <li>E-mail adresu</li>
                        <li>Podatci o računu</li>
                        <li>Poruku u kojoj ćete opisati razlog reklamacije</li>
                    </ul>
                </li>
                <li>
                    Artikle namenjene za povrat adekvatno spakujte kako ne bi došlo do oštećenja u transportu.
                </li>
                <li>
                    Nakon što oštećena roba stigne u naše prostorije i provere opravdanost reklamacije, ispravan artikal biće isporučen na vašu adresu. Ukoliko artikal više nemamo u ponudi, biće izvršen povraćaj novca. Zamena oštećenog artikla ide na trošak prodavca i vrši se preko odgovarajuće kurirske službe.
                </li>
            </ol>
        </div>
    </div>
</template>

<script>
import UserNavigation from '../UserNavigation'

export default {
    name: 'Complaint',
    components: {
        UserNavigation
    }
}
</script>

<style scoped>
* {
    background: #F0EAD6;
}

.text-wrapper {
    margin-top: 20px;
}

h2 {
    font-weight: bold;
}

p {
    font-size: 1.2rem;
}

ol {
    font-size: 1.2rem;
    margin-left: 5%;
}

ul {
    font-size: 1.2rem;
    margin-left: 8%;
}

</style>